/**
 * @fileoverview Contiene los servicios de consumo a la API para Géneros
 *
 * @version 1.0
 *
 * @author José Antonio Rodríguez Barceló <rbsistemas@hotmail.com>
 *
 * @copyright Shuttle Express México
 *
 * Historial
 * ---------
 * La primera versión fue escrita por José Antonio Rodríguez Barceló
 */
import api from '@/services/api'
const END_POINT = '/generos'

export default {
  /**
   * @name getGenders
   * @description Obtiene un listado de documentos segun parametros
   *
   * @param {*} params campo1 -> Parametros para poblar el select
   * @returns {array} devuelve un arreglo de json con los documentos
   */
  getGenders(params) {
    if (params != null) {
      return api.get(END_POINT + params)
    }

    return api.get(END_POINT)
  },

  /**
   * @name postGender
   * @description Se crea el Genero
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para crear el Genero
   */
  postGender(body) {
    return api.post(END_POINT, body)
  },

  /**
   * @name patchGender
   * @description Se actualiza el Genero
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} body Input del formulario -> Propiedades para actualizar el Genero
   * @param {*} id this.editedItem._id -> id del Genero que se va a actualizar
   */
  patchGender(body, id) {
    return api.patch(END_POINT + '/' + id, body)
  },

  /**
   * @name deleteGender
   * @description Elimina un documento por su id
   *
   * @param {*} id _id -> id del documento que se va a eliminar
   * @returns {json} json con el resultado de eliminar el documento
   */
  deleteGender(id) {
    return api.delete(END_POINT + '/' + id)
  },
}
